export default __webpack_public_path__ + "static/media/sign-draw-hover-icon.20ca1691.svg";